import React, { Component } from 'react';


export default class ParallaxLayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
        };

    }


    render() {

        const translateY = this.props.scrollY * this.props.factor

        return (
            <div className={"hero__background hero__background--" + this.props.number}>
                <img src={this.props.url} alt={""} className={"hero__background-inner"} style={{ transform: `translateY(${translateY}px)` }} />
            </div>
        )
    }
}
